'use strict';

var util = require('../util/property-util');
var arrayUtil = require('../util/array-util');
var nocUtil = require('../util/noc-util');
var Highcharts = require('highcharts/highstock');

// Load module after Highcharts is loaded
require('highcharts/modules/exporting')(Highcharts);

module.exports = /*@ngInject*/ ["$filter", "$q", "CsvFactory", "TimeZoneFactory", "LocaleFactory", "ProjectService", "ConfigurationStoreService",
function ($filter, $q, CsvFactory, TimeZoneFactory, LocaleFactory, ProjectService, ConfigurationStoreService) {

    var factory = {};

    var projectConfiguration = ConfigurationStoreService.getProjectConfiguration( ProjectService.getSelectedProjectId());

    (function (Highcharts) {
        "use strict";

        Highcharts.wrap(Highcharts.Pointer.prototype, 'onContainerClick', function (original, e) {
            var pointer = this,
                parent = pointer.chart.container.parentNode,
                bubbleUp = true;

            // Add a method to the event to allow event handlers to prevent propagation if desired
            e.swallowByHighCharts = function () {
                bubbleUp = false;
            };

            // Call the original event
            original.apply(this, Array.prototype.slice.call(arguments, 1));

            // Trigger the event on the container's parent (to bubble the event out of highcharts)
            // unless the user wanted to stop it
            if (bubbleUp && typeof parent !== 'undefined' && parent) {
                jQuery(parent).trigger('click');
            }
        });

    }(Highcharts));

    factory.createYAxis = function (id, color, unit, position, labelsEnabled, labelFunction) {
        var newYAxis = {
            labels: {
                enabled: labelsEnabled,
                formatFunction: labelFunction,
                myunit: unit,
                formatter: function () {
                    var unit = this.axis.options.labels.myunit;
                    var formatFunction = this.axis.options.labels.formatFunction;
                    return formatFunction(this.value, unit);
                },
                align: position == 'left' ? 'right' : 'left',
                style: {
                    color: color
                }
            },
            id: id,
            title: {
                text: ""
            },
            labelsEnabled: labelsEnabled,
            opposite: position == 'left' ? false : true,
            maxPadding: 0,
            minPadding: 0,
            allowDecimals: false
        };
        return newYAxis;
    };

    factory.createSeries = function (data, yAxis, name, formatFunction, object) {
        var newSeries = {
            index: object !== undefined ? object.index : 0,
            name: name,
            yAxis: yAxis.options.index,
            data: data,
            step: projectConfiguration && projectConfiguration.chartConfiguration && projectConfiguration.chartConfiguration.lineChartStep,
            lineWidth: 1,
            marker: {
                radius: 3,
                enabled: false
            },
            formatFunction: formatFunction
        };

        if (util.isDefined(object)) {
            if (util.isDefined(object.dashStyle)) {
                newSeries.dashStyle = object.dashStyle;
            }

            if (util.isDefined(object.bullet)) {
                newSeries.marker.symbol = object.bullet;
            }
            if (util.isDefined(object.color)) {
                newSeries.color = object.color;
            }
            if (util.isDefined(object.rate)) {
                newSeries.rate = object.rate;
            }
        }

        return newSeries;
    };

    factory.createColumnSeries = function (data, yAxis, name, formatFunction, object) {
        var newSeries = {
            name: name,
            yAxis: yAxis.options.index,
            data: data,
            formatFunction: formatFunction,
            type: 'column'
        };

        if (util.isDefined(object)) {
            if (util.isDefined(object.color)) {
                newSeries.color = object.color;
            }
            if (util.isDefined(object.rate)) {
                newSeries.rate = object.rate;
            }
        }

        return newSeries;
    };

    factory.createChart = function (divId) {
        Highcharts.setOptions({
            global: {
                useUTC: false
            }
        });

        (function (H) {
            H.wrap(H.Tooltip.prototype, 'hide', function (defaultCallback) {
                if (!this.isHidden) {
                    defaultCallback.apply(this);
                }
            });
        }(Highcharts));

        var chart = new Highcharts.StockChart($.extend(true, {}, {
            chart: {
                zoomType: 'x',
                renderTo: divId,
                alignTicks: false,
                animation: false,
                resetZoomButton: {
                    theme: {
                        display: 'none'
                    }
                },
                events: {
                    redraw: function () {
                        "use strict";
                        if (util.isDefined(this.deferred)) {
                            this.deferred.resolve();
                        }

                    }
                }
            },
            exporting: {
                filename: divId,
                csv: {
                    itemDelimiter: ";"
                },
                buttons: {
                    contextButton: {
                        enabled: false
                    }
                },
                scale: 1,
                sourceHeight: 720,
                sourceWidth: 1280
            },
            plotOptions: {
                line: {
                    marker: {
                        enabled: false,
                        states: {
                            hover: {
                                radius: 4,
                                lineWidth: 1

                            }
                        }
                    },
                    states: {
                        hover: {
                            lineWidth: 1
                        }
                    },
                    animation: false
                },
                series: {
                    animation: false,
                    states: {
                        hover: {
                            lineWidth: 1,
                            lineWidthPlus: 0
                        }
                    }
                }
            },
            scrollbar: {
                enabled: false,
                liveRedraw: false
            },
            navigator: {
                enabled: false,
                series: {
                    data: [],
                    includeInCSVExport: false
                },
                yAxis: {}

            },
            rangeSelector: {
                enabled: false
            },
            xAxis: [{
                name: 'Date Time',
                type: 'datetime',
                ordinal: false,
                events: {
                    setExtremes: function (event) {
                        var markersEnabled = (event.max - event.min) < 60 * 1000;
                        if (chart.hasOwnProperty('series')) {
                            chart.series.forEach(function (serie) {
                                if (serie.name != "Navigator") {
                                    //serie.options.marker.enabled = markersEnabled;
                                    if (!markersEnabled) {
                                        serie.data.forEach(function (point) {
                                            if (point.graphic) {
                                                point.graphic = point.graphic.destroy();
                                            }
                                        });
                                    }
                                    //serie.yAxis.setExtremes(serie.yAxis.min, serie.yAxis.max);
                                }
                            });
                        }
                        //event.preventDefault();
                    }
                }
            }],
            yAxis: [],
            tooltip: {
                shared: true,
                animation: false,
                shadow: false,
                useHTML: true,
                formatter: function () {
                    if (util.isDefined(this.points)) {
                        var date = new Date(this.x);

                        var htmlContent = "<div><b>Timestamp</b>: " + $filter('date')(date, 'MMM d, HH:mm:ss') + "<br/><br/>";

                        for (var i = 0; i < this.points.length; i++) {
                            if (this.points[i].series.chart.tooltipHidden) {
                                return false;
                            }
                            var color = this.points[i].series.color;
                            var unit = this.points[i].series.yAxis.options.labels.myunit;
                            var value =this.points[i].series.name.includes("Devices") ? Math.round(this.points[i].y): nocUtil.roundToTwo(this.points[i].y);
                            var formattedValue = this.points[i].series.options.formatFunction(value, unit);

                            htmlContent += "<b style=\"color:" + color + "\">■</b> " + this.points[i].series.name + ": <b>" + formattedValue + "</b><br/>";
                        }
                        htmlContent += "</div>";
                        return htmlContent;
                    }
                },
                positioner: function (labelWidth, labelHeight, point) {
                    var newY = this.chart.plotTop;

                    if (point.plotX >= this.chart.plotSizeX / 2) {
                        return {x: (point.plotX + this.chart.plotLeft - labelWidth - 10), y: newY};
                    } else {
                        return {x: point.plotX + this.chart.plotLeft + 10, y: newY};
                    }
                }
            },
            legend: {
                enabled: true,
                maxHeight: 120
            },
            series: []
        }));
        chart.tooltipHidden = false;
        return chart;
    };

    factory.createVuChart = function (divId) {
        Highcharts.setOptions({
            global: {
                useUTC: false
            }
        });
        var chart = new Highcharts.StockChart($.extend(true, {}, {
            chart: {
                zoomType: 'x',
                renderTo: divId,
                alignTicks: false,
                animation: false,
                resetZoomButton: {
                    theme: {
                        display: 'none'
                    }
                }
            },
            exporting: {
                csv: {
                    itemDelimiter: ";"
                },
                buttons: {
                    contextButton: {
                        enabled: false
                    }
                },
                chartOptions: {
                    rangeSelector: {
                        enabled: false
                    },
                    yAxis: {
                        labels: {
                            enabled: true,
                            style: {
                                color: '#000',
                                fontSize: '14px'
                            }
                        }
                    }
                },
                scale: 1,
                sourceHeight: 720,
                sourceWidth: 1280

            },
            plotOptions: {
                line: {
                    marker: {
                        enabled: true,
                        states: {
                            hover: {
                                radius: 4,
                                lineWidth: 1

                            }
                        }
                    },
                    states: {
                        hover: {
                            lineWidth: 1
                        }
                    },
                    animation: false
                },
                series: {
                    animation: false,
                    states: {
                        hover: {
                            lineWidth: 1,
                            lineWidthPlus: 0
                        }
                    }
                },
                column: {
                    stacking: 'normal',
                    marker: {
                        enabled: false
                    }
                }
            },
            scrollbar: {
                enabled: false,
                liveRedraw: false
            },
            navigator: {
                enabled: false,
                series: {
                    data: [],
                    includeInCSVExport: false
                },
                yAxis: {}
            },
            rangeSelector: {
                enabled: false
            },
            xAxis: [{
                name: 'Date Time',
                type: 'datetime',
                ordinal: false
            }],
            yAxis: [],
            tooltip: {
                shared: true,
                animation: false,
                shadow: false,
                useHTML: true,
                formatter: function () {
                    if (util.isDefined(this.points)) {
                        var date = new Date(this.x);
                        var htmlContent = "<div><p><b>Timestamp </b>" + $filter('date')(date, 'MMM d, HH:mm:ss') + "</p>";
                        if (this.points.length > 0) {
                            var timestampSiteMap = this.points[0].series.chart.timestampSiteMap;
                            var site = timestampSiteMap.get(this.x);
                            htmlContent += '<p><i>' + site + '</i></p>'
                        }

                        for (var i = 0; i < this.points.length; i++) {
                            var color = this.points[i].series.color;
                            var unit = this.points[i].series.yAxis.options.labels.myunit;
                            var value = nocUtil.roundToTwo(this.points[i].y);
                            var formattedValue = this.points[i].series.options.formatFunction(value, unit);

                            htmlContent += "<span><b> <i class=\"fa fa-minus\" style=\"color:" + color + "\"></i> " + this.points[i].series.name + ": </b>" + formattedValue + "</span><br/>";
                        }
                        htmlContent += "</div>";
                        return htmlContent;
                    }
                },
                positioner: function (labelWidth, labelHeight, point) {
                    var newY = this.chart.plotTop;
                    if (point.plotX >= this.chart.plotSizeX / 2) {
                        return {x: (point.plotX + this.chart.plotLeft - labelWidth - 10), y: newY};
                    } else {
                        return {x: point.plotX + this.chart.plotLeft + 10, y: newY};
                    }
                }
            },
            legend: {
                enabled: true,
                maxHeight: 60
            },
            series: []

        }));
        return chart;
    };

    factory.createBasicColumnChart = function (divId) {
        var chart = new Highcharts.Chart($.extend(true, {}, {
            chart: {
                renderTo: divId,
                type: 'column'
            },
            title: {
                text: ''
            },
            xAxis: [{
                type: 'category'
            }],
            yAxis: {
                min: 0,
                title: {enabled: false}
            },
            legend: {
                enabled: false
            },
            series: []

        }));
        return chart;

    };

    factory.createPieChart = function (divId) {
        Highcharts.setOptions({
            global: {
                useUTC: false,
                timezoneOffset: TimeZoneFactory.getOffset()
            }
        });
        var chart = new Highcharts.Chart($.extend(true, {}, {
            chart: {
                marginLeft: 300,
                renderTo: divId,
                type: 'pie',
                events: {
                    redraw: function () {
                        "use strict";
                        if (util.isDefined(this.deferred)) {
                            this.deferred.resolve();
                        }

                    }
                }
            },
            tooltip: {
                pointFormat: '{point.y}s: <b>{point.percentage:.1f}%</b>'
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false
                    },
                    showInLegend: true
                }
            },
            legend: {
                align: 'left',
                verticalAlign: 'top',
                layout: 'vertical'
            },
        }));
        return chart;
    };

    factory.createPieDonut = function (divId) {
        var chart = new Highcharts.Chart($.extend(true, {}, {
            chart: {
                type: 'pie',
                renderTo: divId
            },
            title: {
                text: ''
            },
            yAxis: {},
            plotOptions: {
                pie: {
                    shadow: false,
                    center: ['50%', '50%']
                }
            },
            tooltip: {
                valueSuffix: ''
            },
            series: []
        }));
        return chart;
    };

    factory.createPieSeries = function (name, data) {
        var newSeries = {
            name: name,
            colorByPoint: true,
            data: data
        };
        return newSeries;
    };

    factory.createBasicSerie = function (name, data) {
        return {
            name: name, data: data, dataGrouping: {
                enabled: false
            }
        };
    };

    factory.createAreaChart = function (divId) {
        Highcharts.setOptions({
            global: {
                useUTC: false,
                timezoneOffset: TimeZoneFactory.getOffset()
            }
        });

        var chart = new Highcharts.StockChart($.extend(true, {}, {
            chart: {
                zoomType: 'x',
                renderTo: divId,
                alignTicks: false,
                animation: false,
                events: {
                    redraw: function () {
                        "use strict";
                        if (util.isDefined(this.deferred)) {
                            this.deferred.resolve();
                        }

                    }
                }
            },
            exporting: {
                csv: {
                    itemDelimiter: ";"
                },
                buttons: {
                    contextButton: {
                        enabled: false
                    }
                },
                scale: 1,
                sourceHeight: 720,
                sourceWidth: 1280

            },
            plotOptions: {
                area: {
                    fillOpacity: 0.5
                },
                series: {
                    animation: false,
                    states: {
                        hover: {
                            lineWidth: 1,
                            lineWidthPlus: 0
                        }
                    }
                }
            },
            scrollbar: {
                enabled: false,
                liveRedraw: false
            },
            navigator: {
                enabled: false,
                series: {
                    data: [],
                    includeInCSVExport: false
                },
                yAxis: {}

            },
            rangeSelector: {
                enabled: false
            },
            xAxis: [{
                name: 'Date Time',
                type: 'datetime',
                ordinal: false
            }],
            yAxis: [{
                opposite: false
            }],
            tooltip: {
                shared: true,
                animation: false,
                shadow: false,
                useHTML: true,
                positioner: function (labelWidth, labelHeight, point) {
                    var newY = this.chart.plotTop;
                    if (point.plotX >= this.chart.plotSizeX / 2) {
                        return {x: (point.plotX + this.chart.plotLeft - labelWidth - 10), y: newY};
                    } else {
                        return {x: point.plotX + this.chart.plotLeft + 10, y: newY};
                    }
                }
            },
            legend: {
                enabled: false
            },
            series: []
        }));
        return chart;
    };

    factory.createHighStockCSVString = function (chart) {
        "use strict";
        var timestampMap = new Map();
        var formatFunction = function (value) {
            "use strict";
            return $filter('tzdate')(value, 'YYYY-MM-DD HH:mm:ss');
        };
        var propertyNames = [{property: "Timestamp", formatFunction: formatFunction}];
        chart.series.forEach(function (series) {
            "use strict";
            if (series.options.name != "Navigator") {
                var data = series.options.data;
                var id = series.options.name.trim();
                if (series.options.formatFunction.name == "bytesFormater" || series.options.formatFunction.name == "bitsFormater") {
                    propertyNames.push({property: id});
                } else {
                    propertyNames.push({property: id, formatFunction: series.options.formatFunction});
                }
                data.forEach(function (entry) {
                    var entryObject = {
                        0: entry[0],
                        1: entry[1]
                    };

                    if (util.isDefined(entry.x)) {
                        entryObject[0] = entry.x;
                        entryObject[1] = entry.y;
                    }

                    var object = undefined;
                    if (timestampMap.has(entryObject[0])) {
                        object = timestampMap.get(entryObject[0]);
                        if (util.isDefined(entryObject[1])) {
                            object[id] = entryObject[1];
                        }

                    } else {
                        if (util.isDefined(entryObject[1])) {
                            object = {};
                            object[id] = entryObject[1];
                            object["Timestamp"] = new Date(entryObject[0]);
                        }
                    }
                    if (util.isDefined(object)) {
                        timestampMap.set(entryObject[0], object);
                    }
                });
            }
        });

        var array = arrayUtil.getMapValueAsList(timestampMap);
        array.sort(function (a, b) {
            return a.Timestamp.getTime() - b.Timestamp.getTime()
        });
        return CsvFactory.createCSV(array, propertyNames, true, ";");
    };

    return factory;
}];
